module.exports = __webpack_public_path__ + "static/images/ticket-icon.d9129e4.png";